import { FadeIn } from 'components/common/FadeIn';
import styles from './Trees.module.css';

const ProgressBar = ({
  plantedCount,
  goal,
}: {
  plantedCount?: number;
  goal: number;
}) => {
  if (plantedCount == null || goal <= 0) return null;

  const percentage = Math.min((plantedCount / goal) * 100, 100);

  return (
    <FadeIn onScroll>
      <div className={styles.progressBarContainer}>
        <div
          className={styles.progressBarFill}
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={Math.round(percentage)}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Tree planting progress: ${Math.round(percentage)}%`}
        />
      </div>
    </FadeIn>
  );
};

export default ProgressBar;
